const ENCRYPTION_KEY = 'eduone_secret_key_student_portal';

// Helper to encrypt values before saving to cookies
const encrypt = (text) => {
  if (!text) return '';
  const str = typeof text === 'object' ? JSON.stringify(text) : String(text);
  let result = '';
  for (let i = 0; i < str.length; i++) {
    result += String.fromCharCode(str.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length));
  }
  return btoa(unescape(encodeURIComponent(result)));
};

// Helper to decrypt values when reading from cookies
const decrypt = (encryptedText) => {
  if (!encryptedText) return null;
  try {
    const decoded = decodeURIComponent(escape(atob(encryptedText)));
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
      result += String.fromCharCode(decoded.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length));
    }
    try {
      return JSON.parse(result);
    } catch {
      return result;
    }
  } catch (e) {
    console.error('Decryption failed:', e);
    return null;
  }
};

// Save a value to cookies (with encryption by default)
export const setCookie = (name, value, days = 7, encryptValue = true) => {
  const finalValue = encryptValue ? encrypt(value) : value;
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  // Safe default cookie attributes: SameSite=Lax, Secure if page is loaded over HTTPS
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = name + "=" + (finalValue || "") + expires + "; path=/" + secure + "; SameSite=Lax";
};

// Retrieve and decrypt a value from cookies
export const getCookie = (name, decryptValue = true) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const val = c.substring(nameEQ.length, c.length);
      return decryptValue ? decrypt(val) : val;
    }
  }
  return null;
};

// Erase a cookie
export const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax';
};
